import * as Model from "./createInvoiceModel"

export type Action =
  | { type: 'GROUP_SELECTED', groupId: string, value: boolean }
  | { type: 'TAXABLE_CHANGED', groupId: string, value: boolean }
  | { type: 'AMOUNT_CHANGED', groupId: string, value: number }
  | { type: 'DESCRIPTION_CHANGED', groupId: string, value: string }
  | { type: 'PROPOSAL_DESCRIPTION_COPIED', groupId: string }
  | { type: 'INCLUDE_ITEMS_SUMMARY_CHANGED', groupId: string, value: boolean }
  | { type: 'ITEM_GROUPING_OPTION_CHANGED', groupId: string, value: number }
  | { type: 'INCLUDE_DEDUCTION_CHANGED', groupId: string, value: boolean }
  | { type: 'CREDIT_CARD_ENABLED_CHANGED', value: boolean }
  | { type: 'ACH_ENABLED_CHANGED', value: boolean }
  | { type: 'DUE_DATE_CHANGED', value: string }
  | { type: 'SELECTED_ITEMS_CHANGED', groupId: string, selectedItemGuids: string[], selectedItemIds: number[], selectedVisitLaborIds: string[], amount: number }
  | { type: 'SELECTED_VISITS_CHANGED', groupId: string, selectedVisitIds: string[] }
  | { type: 'RESET_WORKAREA_GROUPS', workareaGroups: Model.InvoiceWorkareaGroup[] }
  | { type: 'TAX_CODE_CHANGED', groupId: string, value: number }
  | { type: 'TAX_RATE_ID_CHANGED', groupId: string, value: string | null | undefined }
  | { type: 'WORKAREA_AMOUNT_CHANGED', workareaId: number, value: number }
  | { type: 'SHOW_AUTHORIZE_PAYMENT_ON_FILE_CHANGED', value: boolean }
  | { type: 'REQUIRE_AUTHORIZE_PAYMENT_ON_FILE_CHANGED', value: boolean }
  | { type: 'INCLUDE_PAYMENT_SUMMARY_CHANGED', value: boolean }

export const reducer = (state: Model.NewInvoiceData, action: Action): Model.NewInvoiceData => {
  switch (action.type) {
    case 'GROUP_SELECTED':
      return Model.updateGroupSelection(state, action.groupId, action.value)
    case 'TAXABLE_CHANGED':
      return Model.updateGroupShowSalesTax(state, action.groupId, action.value)
    case 'AMOUNT_CHANGED':
      return Model.updateGroupAmount(state, action.groupId, action.value)
    case 'DESCRIPTION_CHANGED':
      return Model.updateGroupDescription(state, action.groupId, action.value)
    case 'PROPOSAL_DESCRIPTION_COPIED':
      return Model.copyProposalDescription(state, action.groupId)
    case 'INCLUDE_ITEMS_SUMMARY_CHANGED':
      return Model.updateGroupItemsSummary(state, action.groupId, action.value)
    case 'ITEM_GROUPING_OPTION_CHANGED':
      return Model.updateGroupItemGroupingOption(state, action.groupId, action.value)
    case 'INCLUDE_DEDUCTION_CHANGED':
      return Model.updateGroupIncludeDeduction(state, action.groupId, action.value)
    case 'CREDIT_CARD_ENABLED_CHANGED':
      return Model.updateCreditCardEnabled(state, action.value)
    case 'ACH_ENABLED_CHANGED':
      return Model.updateACHEnabled(state, action.value)
    case 'DUE_DATE_CHANGED':
      return Model.updateDueDate(state, action.value)
    case 'SELECTED_ITEMS_CHANGED':
      return Model.updateGroupSelectedItems(
        state, action.groupId, action.selectedItemGuids, action.selectedItemIds, action.selectedVisitLaborIds, action.amount
      )
    case 'SELECTED_VISITS_CHANGED':
      return Model.updateSelectedVisits(state, action.groupId, action.selectedVisitIds)
    case 'RESET_WORKAREA_GROUPS':
      return Model.resetWorkareaGroups(state, action.workareaGroups)
    case 'TAX_CODE_CHANGED':
      return Model.updateGroupSalesTaxId(state, action.groupId, action.value)
    case 'TAX_RATE_ID_CHANGED':
      return Model.updateGroupTaxRateId(state, action.groupId, action.value)
    case 'WORKAREA_AMOUNT_CHANGED':
      return Model.updateWorkareaAmount(state, action.workareaId, action.value)
    case 'SHOW_AUTHORIZE_PAYMENT_ON_FILE_CHANGED':
      return Model.updateShowAuthorizePaymentOnFile(state, action.value)
    case 'REQUIRE_AUTHORIZE_PAYMENT_ON_FILE_CHANGED':
      return Model.updateRequireAuthorizePaymentOnFile(state, action.value)
    case 'INCLUDE_PAYMENT_SUMMARY_CHANGED':
      return Model.updateIncludePaymentSummary(state, action.value)
    default:
      return state
  }
}

